import { interpolateRgbBasis } from 'd3-interpolate'
import { scaleQuantize } from 'd3-scale'

const colors = ['#276419', '#7FBC41', '#B8E186', '#C51B7D', '#8E0152']

/**
 * Create a linear colour scale
 */
export const linearColourScale = interpolateRgbBasis(colors)

/**
 * Generates a colour for maps
 */
export const colorGenerator = (input: number) => {
  return linearColourScale(input)
}

const moreColors = (amountOfColors: number) => {
  const colours = []
  for (let i = 0; i < amountOfColors; i++) {
    colours.push(linearColourScale(i / amountOfColors))
  }
  return colours
}

const quantizedColourScale = scaleQuantize()
  .domain([0, 1])
  .range(moreColors(8))

const tickNumber = 5
const ticks = quantizedColourScale.ticks(tickNumber)
